export default "__VITE_ASSET__RmXqIzZx__"